import {NutAnalyticsClient} from 'nutshell-core/nut-analytics-client';

export const analyticsClient = new NutAnalyticsClient();
